import { SET_TOKEN } from "./actionType";

export const setToken = (token) => {
  return {
    type: SET_TOKEN,
    payload: token,
  };
};
